module.exports = __webpack_public_path__ + "img/jala.f5bfa13c.jpg";